// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".country-select .custom-select[data-v-01a5139d],.state-select .custom-select[data-v-01a5139d]{height:44px!important;padding:0 10px!important}", ""]);
// Exports
module.exports = exports;
